var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoHumanMountain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 102,
    viewBox: "0 0 266 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.244 54.023C175.456 54.9402 184.69 63.9695 202.046 68.209C203.727 68.5877 205.443 68.8497 207.174 68.9923C246.745 72.9658 257.369 91.006 265.5 102H0.5C24.8107 97.2982 21.8558 68.3044 63.4686 66.2113C87.2246 65.017 114.987 53.4158 148.244 54.023Z",
    fill: "url(#paint0_linear_11095_53894)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11095_53894)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M114.087 75.9985C123.682 75.9985 131.459 75.1919 131.459 74.197C131.459 73.2021 123.682 72.3955 114.087 72.3955C104.493 72.3955 96.7148 73.2021 96.7148 74.197C96.7148 75.1919 104.493 75.9985 114.087 75.9985Z",
    fill: "#1386A0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M113.226 27.4983C113.604 28.4035 116.101 31.0761 120.096 31.2361C125.68 31.4598 130.699 26.4954 131.673 24.2968C132.647 22.0983 133.247 23.5398 132.137 26.0331C130.83 28.9665 126.708 35.2642 121.039 35.1413C116.138 35.0346 110.434 31.4983 110.434 31.4983C110.434 31.4983 110.441 28.8924 113.226 27.4983Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.577 46.0257C113.577 46.0257 115.622 54.8687 114.923 57.8687C113.475 64.0791 104.678 72.1013 105.347 72.5457C106.016 72.9902 108.592 73.2317 107.411 73.405C106.23 73.5783 103.341 73.9487 103.623 73.0524C104.097 71.5013 110.087 60.0628 109.745 57.5072C109.403 54.9517 105.853 45.7872 105.853 45.7872C105.853 45.7872 111.488 44.085 113.577 46.0257Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.945 45.4932C113.945 45.4932 126.227 50.2665 125.683 55.3332C125.297 58.8887 118.988 67.8472 119.55 68.5317C120.112 69.2161 121.547 70.3302 121.77 70.7717C121.993 71.2132 117.757 68.7154 117.757 68.7154L121.905 56.3183L106.325 47.4443C108.763 46.439 111.328 45.7823 113.945 45.4932Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.508 18.5891C107.508 18.5891 110.133 14.6454 113.222 16.6736C116.312 18.7017 115.033 24.2291 111.701 24.5254C108.369 24.8217 105.716 21.1328 107.508 18.5891Z",
    fill: "#F4A300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.493 29.0585L114.574 28.2688C114.574 28.2688 113.884 24.6851 114.097 23.0096C114.244 21.8451 110.831 20.374 110.831 20.374L111.493 29.0585Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.748 17.6566C113.748 17.6566 116.732 22.3618 114.417 24.1588C112.95 25.2981 109.548 20.9307 109.568 19.5663C109.589 18.2018 113.291 16.427 113.748 17.6566Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.833 21.5895C110.833 21.5895 109.767 20.6666 109.659 21.3851C109.55 22.1036 110.833 22.9792 111.141 22.5703C111.449 22.1614 110.833 21.5895 110.833 21.5895Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.689 17.2533C113.689 17.2533 111.797 16.9392 111.534 19.4577C111.251 22.1718 108.84 21.3259 108.84 21.3259C108.84 21.3259 107.316 16.6725 113.689 17.2533Z",
    fill: "#F4A300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.468 21.246C107.468 21.246 107.017 20.6016 106.588 20.4564C104.447 19.7246 103.815 23.732 101.065 20.9927C99.5981 19.529 99.0362 20.006 95.9464 22.7335C94.5878 23.9379 94.2827 21.4727 93.7941 21.9423C92.7217 22.9794 94.6891 27.5868 98.2645 24.7572C99.8548 23.4964 99.356 25.7083 102.346 26.3216C106.297 27.1335 108.52 23.4312 107.468 21.246Z",
    fill: "#F4A300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.574 70.8825L103.625 69.4691C103.625 69.4691 109.7 58.5995 109.513 57.8676C109.325 57.1358 107.165 49.3047 107.165 49.3047L114.893 50.081C114.893 50.081 116.038 55.3314 114.893 59.1358C114.015 62.0602 106.574 70.8825 106.574 70.8825Z",
    fill: "#F46277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.579 51.5735C113.579 51.5735 104.882 51.1038 105.847 45.7868C106.525 42.0579 111.619 42.7068 112.517 43.2357C113.415 43.7646 114.539 51.1127 113.579 51.5735Z",
    fill: "#FF8092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.268 65.1571L121.095 66.369C121.095 66.369 126.23 58.449 126.23 55.3334C126.23 49.4075 113.466 44.2979 113.466 44.2979L108.728 49.5023C108.728 49.5023 120.938 55.009 121.063 56.1127C121.176 57.1808 118.268 65.1571 118.268 65.1571Z",
    fill: "#FF8092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4 28.0234C111.4 28.0234 117.796 30.0368 117.469 32.0634C116.463 38.3005 114.975 44.9642 114.975 44.9642C114.975 44.9642 106.288 45.0797 106.485 44.2975C107.06 42.0368 110.138 28.0234 111.4 28.0234Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.673 28.0245C112.673 28.0245 114.791 29.4201 115.716 29.3578C116.64 29.2956 116.508 27.2334 116.508 27.2334C116.508 27.2334 118.041 27.9741 117.743 29.5208C117.527 30.6408 118.59 31.0364 118.688 33.7415C118.72 34.6304 117.491 36.2452 117.297 37.1875C116.615 40.5178 116.615 41.2067 116.615 41.2067C116.615 41.2067 108.684 40.2882 106.785 38.4023C106.785 38.4023 108.106 30.2112 110.532 28.0319C111.184 27.4453 112.673 28.0245 112.673 28.0245Z",
    fill: "#423A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.83 27.6914C112.429 27.9581 115.852 27.8648 118.989 26.007C124.106 22.9744 126.088 15.0959 125.884 12.4025C125.68 9.70921 127.776 11.0499 127.105 15.0988C126.597 18.1566 125.24 27.1359 120.874 30.0307C116.508 32.9255 110.556 32.0603 110.556 32.0603C110.556 32.0603 109.039 30.7033 110.83 27.6914Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.959 27.6147C110.959 27.6147 114.601 27.3703 115.149 27.2266C115.149 27.2266 116.469 31.9969 116.469 32.2843C116.469 32.5717 111.987 34.1273 110.799 33.268C109.61 32.4088 109.22 28.271 110.959 27.6147Z",
    fill: "#423A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.18 27.4983C153.801 28.4035 151.304 31.0761 147.309 31.2361C141.725 31.4598 136.706 26.4954 135.732 24.2968C134.758 22.0983 134.158 23.5398 135.268 26.0331C136.576 28.9665 140.697 35.2642 146.366 35.1413C151.267 35.0346 156.972 31.4983 156.972 31.4983C156.972 31.4983 156.964 28.8924 154.18 27.4983Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.09 28.168C156.09 28.168 149.694 30.1813 150.021 32.208C151.027 38.445 152.515 45.1087 152.515 45.1087C152.515 45.1087 161.202 45.2243 161.005 44.4406C160.435 42.1798 157.357 28.168 156.09 28.168Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.058 21.2793C152.058 21.2793 151.031 19.0275 152.091 17.2882C153.15 15.5489 153.835 16.626 154.467 16.3623C155.964 15.7415 157.859 15.5875 159.24 17.5578C160.621 19.5282 158.382 20.143 159.3 20.626C160.219 21.1089 161.115 21.06 160.425 22.4615C159.736 23.863 157.855 23.0971 157.855 23.9015C157.855 24.706 157.666 25.7919 155.948 25.7786C154.065 25.7638 150.951 24.4689 152.058 21.2793Z",
    fill: "#68504A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.902 28.4813L152.91 28.5287C152.91 28.5287 153.306 25.1538 152.957 23.3627C152.715 22.1183 156.29 20.2812 156.29 20.2812L155.902 28.4813Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.637 17.6582C152.637 17.6582 149.808 22.9797 152.452 24.7219C154.128 25.8271 157.822 22.1012 157.294 19.3679C157.027 17.9219 153.027 16.2953 152.637 17.6582Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.194 18.6192C152.194 18.6192 152.967 16.8503 153.631 18.0488C154.275 19.2133 155.16 18.3703 156.23 18.5733C157.299 18.7762 156.611 21.877 156.56 21.957C156.508 22.037 158.266 20.4977 158.301 19.311C158.337 18.1244 157.37 17.5688 155.911 16.9051C154.453 16.2414 152.164 16.6296 152.194 18.6192Z",
    fill: "#68504A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.705 21.769C156.705 21.769 157.776 20.686 157.959 21.449C158.143 22.212 156.819 23.2668 156.46 22.8505C156.1 22.4342 156.705 21.769 156.705 21.769Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M154.13 75.9985C163.725 75.9985 171.502 75.1919 171.502 74.197C171.502 73.2021 163.725 72.3955 154.13 72.3955C144.536 72.3955 136.758 73.2021 136.758 74.197C136.758 75.1919 144.536 75.9985 154.13 75.9985Z",
    fill: "#1386A0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M153.915 46.1703C153.915 46.1703 151.87 55.0117 152.57 58.0117C154.018 64.2236 162.815 72.2443 162.144 72.6903C161.474 73.1362 158.9 73.3762 160.081 73.548C161.262 73.7199 164.151 74.0932 163.877 73.1969C163.403 71.6458 157.413 60.2073 157.755 57.6503C158.096 55.0932 161.647 45.9317 161.647 45.9317C161.647 45.9317 155.998 44.2295 153.915 46.1703Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.55 45.6357C153.55 45.6357 141.269 50.4076 141.821 55.4772C142.207 59.0328 148.515 67.9913 147.953 68.6757C147.391 69.3602 145.957 70.4728 145.731 70.9143C145.505 71.3557 149.743 68.8594 149.743 68.8594L145.404 55.9143L161.171 47.5928C158.733 46.5863 156.168 45.9276 153.55 45.6357Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.922 71.0265L163.867 69.6117C163.867 69.6117 157.791 58.7436 157.979 58.0102C158.167 57.2769 160.326 49.4473 160.326 49.4473L152.597 50.2236C152.597 50.2236 151.453 55.4754 152.597 59.2799C153.481 62.2043 160.922 71.0265 160.922 71.0265Z",
    fill: "#0C86BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.916 51.7176C153.916 51.7176 162.613 51.2494 161.648 45.9398C160.97 42.2109 155.876 42.8583 154.978 43.3887C154.08 43.919 152.956 51.2583 153.916 51.7176Z",
    fill: "#2095D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.228 65.3012L146.401 66.513C146.401 66.513 141.266 58.593 141.266 55.4775C141.266 49.5515 154.03 44.4404 154.03 44.4404L158.768 49.6449C158.768 49.6449 146.562 55.1486 146.439 56.2567C146.317 57.3249 149.228 65.3012 149.228 65.3012Z",
    fill: "#2095D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.825 28.1661C154.825 28.1661 152.707 29.5602 151.783 29.4994C150.858 29.4387 150.99 27.375 150.99 27.375C150.99 27.375 149.457 28.1157 149.755 29.6624C149.971 30.7824 148.908 31.1765 148.81 33.8831C148.778 34.772 150.007 36.3854 150.2 37.3276C150.883 40.658 151.488 45.1172 151.488 45.1172C151.488 45.1172 160.254 47.8876 162.161 46.0031C162.161 46.0031 159.393 30.3469 156.969 28.1661C156.312 27.5794 154.825 28.1661 154.825 28.1661Z",
    fill: "#F46277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.574 27.6914C154.975 27.9581 151.552 27.8648 148.415 26.007C143.298 22.9744 141.316 15.0959 141.52 12.4025C141.724 9.70921 139.626 11.0499 140.302 15.0988C140.809 18.1566 142.167 27.1359 146.533 30.0307C150.899 32.9255 156.851 32.0603 156.851 32.0603C156.851 32.0603 158.365 30.7033 156.574 27.6914Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54 27.7592C156.54 27.7592 152.897 27.5148 152.35 27.3711C152.35 27.3711 151.029 32.1415 151.029 32.4289C151.029 32.7163 155.511 34.2718 156.698 33.4111C157.885 32.5504 158.274 28.4141 156.54 27.7592Z",
    fill: "#FF8092"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11095_53894",
    x1: 132.882,
    y1: 58.2386,
    x2: 132.942,
    y2: 89.6449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1EBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D2EBF4",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D5EDF5",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D9EEF6",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DFF1F7",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E7F5F9",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F1F9FC",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FCFEFE",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11095_53894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 65,
    fill: "white",
    transform: "translate(93.5 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoHumanMountain);
export default __webpack_public_path__ + "static/media/two_human_mountain.852fd88feaba3f52ed4648ce6b71c7be.svg";
export { ForwardRef as ReactComponent };